import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-143a7251"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("canvas", {
  id: "graph-canvas",
  style: {"width":"800px","height":"450px"}
}, null, -1))
const _hoisted_3 = { class: "zone-container" }
const _hoisted_4 = {
  key: 0,
  class: "inspect-container"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "text" }
const _hoisted_8 = ["onClick", "title"]
const _hoisted_9 = { class: "stats" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imageColorMap, ([image, color]) => {
        return (_openBlock(), _createElementBlock("div", {
          key: image,
          style: _normalizeStyle(`color: ${color}`)
        }, _toDisplayString(image.replaceAll("_", " ")), 5))
      }), 128))
    ]),
    (_ctx.selectedNode !== undefined)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", {
            class: "image",
            style: _normalizeStyle(`border-top-color: ${
          _ctx.selectedNode.data.image === undefined
            ? 'white'
            : _ctx.imageColorMap.get(_ctx.selectedNode.data.image)
        };`)
          }, [
            _createElementVNode("img", {
              src: `img/scenes/${
            _ctx.selectedNode.data.image === undefined
              ? 'LOADING'
              : _ctx.selectedNode.data.image
          }.jpg`
            }, null, 8, _hoisted_5),
            (_ctx.selectedNode.data.character !== undefined)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "character",
                  src: `img/characters/${_ctx.selectedNode.data.character}.png`
                }, null, 8, _hoisted_6))
              : _createCommentVNode("", true)
          ], 4),
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.selectedNode.data.text), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedNode.data.choices, (choice) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "choice",
              onClick: ($event: any) => (_ctx.onChoiceClick(choice)),
              key: choice.text + choice.next,
              title: choice.next
            }, _toDisplayString(choice.text), 9, _hoisted_8))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.content, (val) => {
        return (_openBlock(), _createElementBlock("ul", { key: val }, [
          _createElementVNode("li", null, _toDisplayString(val), 1)
        ]))
      }), 128))
    ])
  ]))
}